import { combineReducers } from "redux";
import { reducersUsers } from "../store/ducks/users";
import { reducersProviders } from "../store/ducks/providers";
import { reducersStores } from "../store/ducks/stores";
import { reducersConfig } from "../store/ducks/config";
export default combineReducers({
  users: reducersUsers,
  providers: reducersProviders,
  stores: reducersStores,
  config: reducersConfig,
});
